// extracted by mini-css-extract-plugin
export default {"wrap":"main_wrap__Q-ai3","row":"main_row__C45+e","img":"main_img__A5pqZ","item":"main_item__iSPxE"};